module.exports = __webpack_public_path__ + "img/product.d2dc90d8.png";